import React from 'react';
import * as Yup from 'yup';
import { firestore } from '../firebase';
import * as RFIcon from 'react-feather'; 
import language from '../languages';
import buildQuery from "./EntityUtil";

const meta = (lang) => {
    return {
        entityName: 'Cuisines',
        entityTitle: 'Cuisines',
        headerIcon: <RFIcon.Clipboard strokeWidth={2} />,
        emptyRow: () => {
            return {
                label: '',
                value: '',
                shortDescription: '',
                description: '',
                recommDishes: '',
                redWines: '',
                whiteWines: '',
                image: 'https://via.placeholder.com/800',
                isActive: true,
            }
        },
        collection: 'cuisines',
        addButtonText: 'New Cuisine',
        fields: [
            { name: 'label', default: null, dataType: 'string', label: 'Cuisine Name', input: 'text' },
            { name: 'value', default: null, dataType: 'string', label: 'Cuisine Code', input: 'text', disableValue: 'id',
                isDisabled: (value)=> {
                    if(value){
                        return true
                    }else{
                        return false
                    }
                }
            },
            { name: 'description', default: null, dataType: 'string', label: 'Description', input: 'text', multiline: true, rows: 4 },
            { name: 'shortDescription', default: null, dataType: 'string', label: 'Short Description', input: 'text', multiline: true, rows: 2 },
            { name: 'recommDishes', default: null, dataType: 'string', label: 'Recommended Dishes', input: 'text', multiline: true, rows: 2 },
            { name: 'redWines', default: null, dataType: 'string', label: 'Red Wine list (name | url) (Separated with ";")', input: 'text', multiline: true, rows: 3 },
            { name: 'whiteWines', default: null, dataType: 'string', label: 'White Wine list (name | url) (Separated with ";")', input: 'text', multiline: true, rows: 3 },
             {name: 'image', default: null, dataType: 'string', label: 'Image', input: 'file'},
             {name: 'isActive', default: true, dataType: 'boolean', label: 'Activate', input: 'switch', color: 'primary'},
        ],
        table: [
            {name: 'image', type: 'field', label: 'Image',
                render: (doc)=> {
                    return (
                        <img component="span" alt={doc.label} src={doc.image} style={{height:75}} />
                    )}
            },
            { name: 'label', type: 'field', label: 'Name' },
            { name: 'value', type: 'field', label: 'Code' },
            { name: 'actions', type: 'action', label: 'Actions', actions: ['delete', 'edit'] }
        ],
        validationSchema: Yup.object({
            label: Yup.string()
                .required(language[lang].Field_Required),
            value: Yup.string()
                .required(language[lang].Field_Required),
            description: Yup.string()
                .required(language[lang].Field_Required),
            shortDescription: Yup.string()
                .required(language[lang].Field_Required),
            recommDishes: Yup.string()
                .required(language[lang].Field_Required),
            redWines: Yup.string()
                .required(language[lang].Field_Required),
            whiteWines: Yup.string()
                .required(language[lang].Field_Required),
            image: Yup.string()
                .required(language[lang].Field_Required),
        }),
        filterObject: [],
        getQuery: (paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage) => {
            let query = {};
            query = firestore.collection('cuisines');
            return buildQuery(query, paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage);
        },
        defaultOrderBy: ['label', 'asc'],
        searchableColumns: ['label','value'],
        beforeSave: async (user, doc) => {
            return doc
        }
    }
}

export default meta;